import React from 'react';
import newline1 from './assets/img/newline1.jpg'
import newline3 from './assets/img/newline3.jpg'
import newline7 from './assets/img/newline7.jpg'
import newline6 from './assets/img/newline6.jpg'
import newline4 from './assets/img/newline4.jpg'
import newline5 from './assets/img/newline5.jpg'
import newline8 from './assets/img/newline8.jpg'
import newline9 from './assets/img/newline9.jpg'
import './App.css';
import Frame from "./Entreprise/Frame";
import Collection from "./Collection/Collection";

function App() {
  return (
    <div className="App">
        <Collection/>
        <div className="background">
        <h1>Visitez nos projets d'inspiration de façon virtuelle !</h1>
        <h3>D’autres visites seront ajoutées prochainement</h3>
        <div className="container-all">
            <a href="/thomas&piron/newline1">
                <div className="container">
                    <img src={newline1} alt=""/>
                    <span className="title">NewLine 1</span>
                </div>
            </a>
            <a href="/thomas&piron/newline3">
            <div className="container">
                <img src={newline3} alt=""/>
                    <span className="title">NewLine 3</span>
            </div>
            </a>
            <a href="/thomas&piron/newline4">
                <div className="container">
                    <img src={newline4} alt=""/>
                    <span className="title">NewLine 4</span>
                </div>
            </a>
            <a href="/thomas&piron/newline5">
                <div className="container">
                    <img src={newline5} alt=""/>
                    <span className="title">NewLine 5</span>
                </div>
            </a>
            <a href="/thomas&piron/newline6">
                <div className="container">
                    <img src={newline6} alt=""/>
                    <span className="title">NewLine 6</span>
                </div>
            </a>
            <a href="/thomas&piron/newline7">
                <div className="container">
                    <img src={newline7} alt=""/>
                    <span className="title">NewLine 7</span>
                </div>
            </a>
            <a href="/thomas&piron/newline8">
                <div className="container">
                    <img src={newline8} alt=""/>
                    <span className="title">NewLine 8</span>
                </div>
            </a>
            <a href="/thomas&piron/newline9">
                <div className="container">
                    <img src={newline9} alt=""/>
                    <span className="title">NewLine 9</span>
                </div>
            </a>
        </div>
        </div>
        <Frame/>
    </div>
  );
}

export default App;
